import styled from 'styled-components';
import { TextBlock } from '../text';
import { FontSize14 } from '../fonts';
import { MarginTop10 } from '../margins';

export const TextPrivacy = styled(TextBlock)`
    ${FontSize14};
    margin-top: 18px;
    width: 100%;
    text-align: left;
`;

export const RadioButtonWrapper = styled.div`
    ${MarginTop10};
    margin-right: 36px;
`;

export const RadioButtonsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;